/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { equal } from '@ember/object/computed';
import Component from '@ember/component';
import { isBlank, isNone } from '@ember/utils';
import { PLATFORM_LABELS } from 'cio/utils/push/platforms';

@tagName('')
export default class PreviewContainer extends Component {
  // external API
  template = null;

  preview = null;
  isRefreshing = false;
  selectedCustomer = null;
  currentTab = null;

  // internal API
  @equal('template.editor', 'json') isJsonEditor;

  @computed('template.action.sendToPlatform')
  get targetPlatformLabel() {
    return PLATFORM_LABELS[this.get('template.action.sendToPlatform')];
  }

  @computed('selectedCustomer.devices.content', 'preview.to')
  get customerDevice() {
    let { selectedCustomer, preview } = this;

    if (
      preview &&
      !isBlank(preview.to) &&
      preview.to !== 'all' &&
      !isNone(selectedCustomer) &&
      selectedCustomer.devices.content
    ) {
      return selectedCustomer.devices.content.find((device) => device.id === preview.to);
    }

    return null;
  }

  @computed('template.action.{isPlatformDefault,sendToPlatform}', 'customerDevice')
  get platformMismatch() {
    let { customerDevice } = this;
    if (this.get('template.action.isPlatformDefault') || isNone(customerDevice)) {
      return false;
    }

    return this.get('template.action.sendToPlatform') !== customerDevice.platform;
  }
}
